import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=07f5e71d&scoped=true"
import script from "./NewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5e71d",
  null
  
)

export default component.exports